<template>
  <div v-if="this.$route.path==='/survey'" class="wrap">
    <NoInfobar />
    <div class="contents" id="size">
        <!-- swiper-container -->
        <!-- <Swiper/> -->
        <!-- //swiper-container -->

        <!-- Main -->
        <router-view :key="$route.fullPath"/>
        <!-- Main -->
        <!-- <div class="footer">
                    © ILJIN ALL RIGHTS RESERVED.
                </div> -->
      </div>
  </div>
  <div v-else-if="this.$store.state.loginInfo !== null && this.$store.state.token !== ''" class="wrap">
    <!-- header -->
    <!-- $route.path.substr(0,7)!=='/mobile' -->
    <Navbar v-if="$route.path!=='/login'" ref="refNavBar" />

    

    <!-- //header -->
    <!-- $route.path.substr(0,7)=='/mobile' -->
    <div id="app" v-if=" $route.path=='/login'" >
      <router-view :key="$route.fullPath"/>
    </div>
    
    <div id="app" v-else>
        <div class="todo-box" v-if="$store.state.loginInfo.groupUId !== 29 && $store.state.loginInfo.id">
            <div v-for="(todo,i) in todos" :key="i" style="padding-bottom: 12px;">
                <el-link v-if="todo.itemId === 1" icon="el-icon-warning-outline" type="info" style="color: white;">{{ todo.itemNm }}</el-link>
                <el-link v-else-if="todo.itemId === 2" icon="el-icon-shopping-cart-full" type="info" style="color: white;">{{ todo.itemNm }}</el-link>
                <el-link v-else-if="todo.itemId === 3" icon="el-icon-s-custom" type="info" style="color: white;">{{ todo.itemNm }}</el-link>
                <el-link v-else-if="todo.itemId === 4" icon="el-icon-service" type="info" style="color: white;">{{ todo.itemNm }}</el-link>
                <el-link @click.native.stop="$router.push({path: todo.html})" style="margin-left: 2em; color: white;">{{ todo.itemCnt }}</el-link>
                <el-link @click.native.stop="$router.push({path: todo.html1})" type="danger" style="margin-left: 2em;">({{ todo.itemCnt1 }})</el-link>
                <el-divider class="todo-divider" v-if="i < todos.length-1" direction="vertical"></el-divider>
            </div>
        </div>
      <!-- lnb -->
      <Menu ref="menu"/>
      <!-- //lnb -->
      <!-- contents -->  
      <div class="contents" id="size" @click="$refs.menu.removeOn()">
        <!-- swiper-container -->
        <!-- <Swiper/> -->
        <!-- //swiper-container -->

        <!-- 권한 테스트용 출력 -->
       <!-- <div style="text-align: center;">
           해당 페이지의 권한은 {{ getGrants }}
       </div> -->
        <!-- Main -->
        <router-view :key="$route.fullPath"/>
        <!-- Main -->
        <!-- <div class="footer">
                    © ILJIN ALL RIGHTS RESERVED.
                </div> -->
      </div>
    </div>
    <div class="vld-parent" v-show="this.$store.state.isLoading">
      <loading :active.sync="this.$store.state.isLoading" 
               :can-cancel="false" 
               :is-full-page="true"
               color="#6799FF"
               :opacity="0.1"></loading>
    </div>
    <!-- //contents -->
  </div>
  <div v-else>
    <Login/>
    <div class="vld-parent" v-show="this.$store.state.isLoading">
      <loading :active.sync="this.$store.state.isLoading" 
               :can-cancel="false" 
               :is-full-page="true"
               color="#6799FF"
               :opacity="0.1"></loading>
    </div>
  </div>
</template>

<script>
    import Navbar from "@/components/Navbar.vue";
    import NoInfobar from "@/components/NoInfobar.vue";
    import Menu from "@/components/Menu.vue";
    import Login from "@/components/Login.vue";
    import MyMain from "@/views/Main/main.vue";
    import router from './router';
    
    // eslint-disable-next-line import/first
    import Loading from 'vue-loading-overlay';

    export default {
        name: "App",
        components: {Navbar, NoInfobar, Menu, Login, MyMain, Loading},
        data() {
            return {
                isOpen: true,
                route: router,
                isLoading: false,
                todos: [],
            };

        },
        watch: {
            '$route': {
                deep: true,
                immediate: true,
                async handler(to, from, next) {
                    
                    const {url} = this.$menu.getGrants();
                    /**
                     * * 메인화면을 사용 docList 으로 무족건 이동.
                     */
                    const {groupUId} = this.$store.state.loginInfo;
                    if(groupUId) { //로그인한 사용자
                        if(url === to.path) {   //부여된 권한에 맞는 페이지가 맞다면 next()
                            try {
                                if(groupUId !== 29) {//(대행사는 제외)
                                    if(to.path !== from.path) {//라우터가 변경시마다 Todo List를 호출한다. 
                                        await this.openTodoListModal();
                                    } else {
                                        next();
                                    }
                                }
                                if(!(to.path ==='/survey' || to.path ==='/AgencyReg')){
                                    // 설문조사페이지 or 대행사 호출인경우 상단 공지사항을 로딩못하도록 막음
                                    this.$refs.refNavBar.getNotices();
                                }
                            } catch(_){}
                        } else {
                            if(url) {
                                this.$swal({
                                    type: 'warning',
                                    text: '권한이 없는 페이지 입니다.'
                                }).then( _ => {
                                    if(groupUId === 29) {
                                        this.$router.push({path: `/AgencyReg`});
                                    } else {
                                        this.$router.push({path: `/DocList`});
                                    }
                                })
                            } else {
                                //대체로 새로고침 시 여기를 탐..
                                console.log("새로고침 영역")
                                if(groupUId === 29) {
                                    this.$router.push({path: `/AgencyReg`});
                                }
                            }
                        }
                    } else { //로그인 정보가 없는 사용자
                        if(to.path === '/login') {
                            console.log("로그인 화면")
                        } else {
                            if(this.$router.history._startLocation && this.$router.history._startLocation.indexOf('/survey') !== -1) {
                                console.log("설문조사 화면")
                            } else {
                                this.$router.push({path: `/login`});
                            }
                        }
                    }
                    
                }
            }
        },
        computed: {
            getGrants() {
                const {grantDelete, grantInsert, grantPrint, grantSelect, grantUpdate} = this.$menu.getGrants();
                return {grantDelete, grantInsert, grantPrint, grantSelect, grantUpdate}
            }
        },
        created() {

            if (!Array.prototype.filter) {
                Array.prototype.filter = function (func, thisArg) {
                    'use strict';
                    // eslint-disable-next-line valid-typeof
                    if (!((typeof func === 'Function' || typeof func === 'function') && this))
                        throw new TypeError();

                    var len = this.length >>> 0,
                        res = new Array(len), // preallocate array
                        t = this, c = 0, i = -1;

                    if (thisArg === undefined) {
                        while (++i !== len) {
                            // checks to see if the key was set
                            if (i in this) {
                                if (func(t[i], i, t)) {
                                    res[c++] = t[i];
                                }
                            }
                        }
                    } else {
                        while (++i !== len) {
                            // checks to see if the key was set
                            if (i in this) {
                                if (func.call(thisArg, t[i], i, t)) {
                                    res[c++] = t[i];
                                }
                            }
                        }
                    }

                    res.length = c; // shrink down array to proper size
                    return res;
                };
            }

            this.$http.defaults.headers['x-auth-token'] = this.$store.state.loginInfo.token;
            // server session check
            this.$http.get('/api/').catch(() => {
                this.$store.commit('logout');
                this.$cookie.delete('loginInfo');
            })

            if (this.$cookie.get('loginInfo') !== null) {
                this.$store.commit('login', JSON.parse(this.$cookie.get('loginInfo')));

                const loginInfo = {};
                loginInfo.loginId = this.$store.state.loginInfo.loginId;
                loginInfo.token = this.$store.state.loginInfo.token;
                loginInfo.menu = this.$store.state.loginInfo.menu;
                loginInfo.authorities = this.$store.state.loginInfo.authorities;
                loginInfo.loginPw = 'Not Use';
            }
        },
        mounted() {

            // eslint-disable-next-line
            dhtmlx.image_path = "/dhtmlx/imgs/";
            // eslint-disable-next-line
            dhtmlXCalendarObject.prototype.langData.ko = {
                // date format
                dateformat: "%Y-%m-%d",
                // full names of months
                monthesFNames: [
                    "1월",
                    "2월",
                    "3월",
                    "4월",
                    "5월",
                    "6월",
                    "7월",
                    "8월",
                    "9월",
                    "10월",
                    "11월",
                    "12월"
                ],
                // short names of months
                monthesSNames: [
                    "1월",
                    "2월",
                    "3월",
                    "4월",
                    "5월",
                    "6월",
                    "7월",
                    "8월",
                    "9월",
                    "10월",
                    "11월",
                    "12월"
                ],
                // full names of days
                daysFNames: [
                    "일요일",
                    "월요일",
                    "화요일",
                    "수요일",
                    "목요일",
                    "금요일",
                    "토요일"
                ],
                // short names of days
                daysSNames: ["일", "월", "화", "수", "목", "금", "토"],
                // starting day of a week. Number from 1(Monday) to 7(Sunday)
                weekstart: 0,
                // the title of the week number column
                weekname: "주"
            };
            // eslint-disable-next-line
            dhtmlXCalendarObject.prototype.lang = "ko";
            this.$store.commit('finish');
        },
        methods: {
            serverSessionCheck() {

            },
            openTodoListModal() {
                const {id, compCd, groupUId} = this.$store.state.loginInfo;
                
                if(id && compCd) {
                    this.$http.post(`/api/common/toDoList/list`,{
                        companyId: compCd,
                        userId: (groupUId == 19 || groupUId == 2) ? 0 : id,
                    })
                    .then(response => {
                        this.todos = response.data;
                    })
                    .finally(_ => {
                        $(".todo-box").draggable({'cancel':'.modal-card-body', containment : 'body' });
                    });
                } else {
                    console.log("??")
                }
            }
        },
    };
</script>

<style>

</style>
